import { render, staticRenderFns } from "./VPSPwdLessOtpValidate.vue?vue&type=template&id=6f2fffb1&scoped=true"
import script from "./VPSPwdLessOtpValidate.vue?vue&type=script&lang=js"
export * from "./VPSPwdLessOtpValidate.vue?vue&type=script&lang=js"
import style0 from "./VPSPwdLessOtpValidate.vue?vue&type=style&index=0&id=6f2fffb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fffb1",
  null
  
)

export default component.exports